import React, {useEffect} from 'react';

import {createBrowserHistory} from 'history';
import {baseName} from './config/keys';
import {useDispatch, useSelector} from 'react-redux';
import {closeMsg} from './redux-app';
import {DSThemeProvider} from './components/DSThemeCtx';
import {Router} from 'react-router-dom';
import Routes from './Routes';
import {Box} from '@mui/material';

//DS
import {DialogDs, LoadingModal, Sidebar} from 'lib.front';
import {useVerificar} from './hooks';

import {QueryClient, QueryClientProvider} from '@tanstack/react-query';

const browserHistory = createBrowserHistory({basename: baseName});

const queryClient = new QueryClient();

function stateSelector(state) {
   return {
      loading: state.loading.open,
      modalProps: state.modal,
      msgProps: state.msg,
      overlayProps: state.overlay,
      sidebarProps: state.sidebar,
      auth: state.auth
   };
}

function AppDS() {
   const {loading, modalProps, msgProps, overlayProps, sidebarProps, auth} = useSelector(
      stateSelector
   );
   const dispatch = useDispatch();
   const verificar = useVerificar();
   useEffect(() => {
      verificar();
   }, []);

   function handleCloseMsgModal() {
      dispatch(closeMsg());
   }

   return (
      <DSThemeProvider>
         <QueryClientProvider client={queryClient}>
            <Router basename={baseName} history={browserHistory}>
               <Routes logged={auth.logged} />
            </Router>
            <Box {...overlayProps} />
            <DialogDs {...modalProps} />
            <Sidebar {...sidebarProps} />
            <LoadingModal open={loading} />
            <DialogDs titulo="Aviso" onClose={handleCloseMsgModal} {...msgProps}></DialogDs>
         </QueryClientProvider>
      </DSThemeProvider>
   );
}

export default AppDS;
